/* Split parent links and accessible submenu toggles retain every destination. */
(() => {
 const bind=root=>{
  if(root.dataset.navigationReady){root.tshMeasureHeader?.();return;}root.dataset.navigationReady='true';
  const desktop=matchMedia('(min-width:1001px)');
  const items=[...root.querySelectorAll('[data-nav-item]')];
  const scrim=root.querySelector('[data-nav-scrim]');
  const mobile=root.querySelector('.tsh-mobile-menu'),mobileToggle=root.querySelector('.tsh-menu-toggle');
  const back=root.querySelector('[data-drawer-back]'),drawerTitle=root.querySelector('[data-drawer-title]');
  let timer;
  const panel=item=>item.querySelector(':scope > [data-submenu-panel]');
  const toggle=item=>item.querySelector(':scope > .tsh-menu-label > [data-submenu-toggle]');
  const syncMobile=()=>{
   const active=mobile.querySelector('.tsh-mobile-primary>.tsh-menu-item.is-open');
   mobile.classList.toggle('has-active-menu',!!active);
   if(back)back.hidden=!active;
   if(drawerTitle)drawerTitle.textContent=active?.querySelector(':scope>.tsh-menu-label>a')?.textContent.trim()||drawerTitle.dataset.default;
  };
  const syncScrim=()=>{scrim.hidden=!desktop.matches||!items.some(i=>panel(i)&&!panel(i).hidden);syncMobile();};
  const close=item=>{const p=panel(item),t=toggle(item);if(p)p.hidden=true;if(t)t.setAttribute('aria-expanded','false');item.classList.remove('is-open');delete item.dataset.openedBy;syncScrim();};
  const closeAll=()=>{items.forEach(close);scrim.hidden=true;clearTimeout(timer);};
  const position=()=>{
   const content=root.querySelector('.tsh-header-inner').getBoundingClientRect();
   root.style.setProperty('--tsh-nav-top',`${root.getBoundingClientRect().bottom}px`);
   root.style.setProperty('--tsh-nav-content-width',`${content.width}px`);
   root.style.setProperty('--tsh-nav-gutter',`${content.left}px`);
  };
  const wrapper=root.closest('.tsh-shared-header');
  const measure=()=>{
   if(wrapper){
    const height=Math.max(0,root.getBoundingClientRect().top-wrapper.getBoundingClientRect().top);
    wrapper.style.setProperty('--tsh-announcement-height',`${height}px`);
   }
   position();
  };
  root.tshMeasureHeader=measure;
  // Scrolling never hides/reveals content with JS. Only the open fixed menu
  // needs its offset updated as the native sticky header reaches the top.
  const onScroll=()=>{if(desktop.matches&&!scrim.hidden)position();};
  const open=(item,source='keyboard')=>{
   const p=panel(item),t=toggle(item);if(!p||!t)return;
   if(p.hidden||source!=='hover')item.dataset.openedBy=source;
   items.filter(i=>i!==item&&i.parentElement===item.parentElement).forEach(close);
   p.hidden=false;t.setAttribute('aria-expanded','true');item.classList.add('is-open');position();
   syncScrim();
   if(!desktop.matches)mobile.scrollTop=0;
  };
  items.forEach(item=>{
   const t=toggle(item),p=panel(item);if(!t||!p)return;
   t.addEventListener('click',()=>{clearTimeout(timer);if(p.hidden||item.dataset.openedBy==='hover')open(item,'click');else close(item);});
   t.addEventListener('keydown',e=>{if(e.key==='ArrowDown'){e.preventDefault();open(item);p.querySelector('a')?.focus();}});
   item.addEventListener('pointerenter',e=>{if(desktop.matches&&e.pointerType==='mouse'){clearTimeout(timer);open(item,'hover');}});
   item.addEventListener('pointerleave',e=>{if(desktop.matches&&e.pointerType==='mouse')timer=setTimeout(()=>close(item),180);});
   item.addEventListener('focusout',()=>setTimeout(()=>{if(desktop.matches&&!item.contains(document.activeElement))close(item);},0));
   item.addEventListener('keydown',e=>{if(e.key==='Escape'&&!p.hidden){e.preventDefault();e.stopPropagation();close(item);t.focus();}});
  });
  root.querySelectorAll('[data-group-toggle]').forEach(t=>t.addEventListener('click',()=>{
   const p=document.getElementById(t.getAttribute('aria-controls'));
   const expanded=t.getAttribute('aria-expanded')==='true';
   if(!desktop.matches&&!expanded)root.querySelectorAll('.tsh-mobile-menu [data-group-toggle]').forEach(other=>{
    if(other!==t){other.setAttribute('aria-expanded','false');const target=document.getElementById(other.getAttribute('aria-controls'));if(target)target.hidden=true;}
   });
   t.setAttribute('aria-expanded',String(!expanded));p.hidden=expanded;
  }));
  back?.addEventListener('click',()=>{const active=mobile.querySelector('.tsh-menu-item.is-open');closeAll();mobile.scrollTop=0;if(active)toggle(active)?.focus();});
  root.addEventListener('tsh:drawer-close',()=>{
   closeAll();root.querySelectorAll('.tsh-mobile-menu [data-group-toggle]').forEach(t=>{t.setAttribute('aria-expanded','false');const p=document.getElementById(t.getAttribute('aria-controls'));if(p)p.hidden=true;});
  });
  root.querySelectorAll('[data-mega-browser]').forEach(browser=>{
   const tabs=[...browser.querySelectorAll('[data-mega-tab]')];
   const activate=tab=>{
    tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;document.getElementById(t.getAttribute('aria-controls')).hidden=!active;});
   };
   tabs.forEach((tab,index)=>{
    tab.addEventListener('click',()=>activate(tab));
    tab.addEventListener('keydown',e=>{
     let next;
     if(e.key==='ArrowDown')next=(index+1)%tabs.length;
     if(e.key==='ArrowUp')next=(index-1+tabs.length)%tabs.length;
     if(e.key==='Home')next=0;
     if(e.key==='End')next=tabs.length-1;
     if(next!==undefined){e.preventDefault();tabs.forEach(t=>t.tabIndex=-1);tabs[next].tabIndex=0;tabs[next].focus();}
     if(e.key==='ArrowRight'){e.preventDefault();activate(tab);document.getElementById(tab.getAttribute('aria-controls')).querySelector('a')?.focus();}
    });
   });
  });
  root.querySelectorAll('.tsh-nav a,.tsh-mobile-menu a').forEach(a=>a.addEventListener('click',closeAll));
  root.querySelector('[data-search-open]')?.addEventListener('click',()=>{closeAll();root.tshCloseDrawer?.();});
  scrim.addEventListener('click',closeAll);
  const outside=e=>{if(!root.contains(e.target))closeAll();};
  const resize=()=>{closeAll();position();if(desktop.matches){mobile.hidden=true;mobileToggle.setAttribute('aria-expanded','false');}};
  document.addEventListener('pointerdown',outside);desktop.addEventListener('change',resize);
  const observer=new ResizeObserver(measure);observer.observe(root.querySelector('.tsh-header-inner'));if(wrapper)observer.observe(wrapper);measure();
  window.addEventListener('scroll',onScroll,{passive:true});
  root.addEventListener('shopify:section:unload',()=>{closeAll();observer.disconnect();window.removeEventListener('scroll',onScroll);document.removeEventListener('pointerdown',outside);desktop.removeEventListener('change',resize);delete root.tshMeasureHeader;},{once:true});
 };
 const init=()=>document.querySelectorAll('[data-tsh-section=header]').forEach(bind);
 init();document.addEventListener('shopify:section:load',init);
})();
